"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns sold days
 * @param {string} value
 * @returns {number}
 */
const getSoldDays = (value) => {
    const splitVal = `${value}`.split('.'); // gives an array
    const days = splitVal[0];
    return Number(days);
};
exports.default = getSoldDays;
